import { supabase } from "../supabase/SupabaseClient";

/* Búsqueda GENERAL del hub (más allá de los padrones que están en memoria):
 * vales de urea, siniestros, garantías. Es la mitad "a la red" del buscador —
 * el spotlight que pidió Nacho (24/09): «que pueda buscar cualquier cosa».
 *
 * ── ADITIVA, Y POR ESO NO PUEDE ROMPER EL BUSCADOR ───────────────────────
 *
 * El buscador de padrones (interno/patente/apellido) NO depende de esto: sigue
 * andando en memoria, en la misma tecla. Esto suma categorías abajo. Si la RPC
 * falla, tarda o el usuario no tiene permiso, devolvemos [] y el buscador se ve
 * igual que siempre. Nunca lanza: el que busca un camión no puede quedarse sin
 * respuesta porque el backend de siniestros tuvo un mal día.
 *
 * ── EL PERMISO LO PONE EL SERVIDOR ───────────────────────────────────────
 *
 * `buscar_global` es SECURITY DEFINER y gatea cada entidad con el MISMO permiso
 * que gatea su pantalla (ver.urea/ver.combustible, ver.trafico…). Así el front
 * no decide qué puede ver cada uno —eso se prueba en la base— y no hay forma de
 * que aparezca un resultado de un sector al que no se entra.
 */
export async function buscarGlobal(texto) {
  const q = (texto || "").trim();
  if (q.length < 2) return [];
  try {
    const { data, error } = await supabase.rpc("buscar_global", { q });
    if (error) return [];
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
